/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface GradeTaskResponseContent
 */
export interface GradeTaskResponseContent {
    /**
     * Human-readable confirmation message.
     * @type {string}
     * @memberof GradeTaskResponseContent
     */
    message?: string;
}


/**
 * Check if a given object implements the GradeTaskResponseContent interface.
 */
export function instanceOfGradeTaskResponseContent(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function GradeTaskResponseContentFromJSON(json: any): GradeTaskResponseContent {
    return GradeTaskResponseContentFromJSONTyped(json, false);
}

export function GradeTaskResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GradeTaskResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function GradeTaskResponseContentToJSON(value?: GradeTaskResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
    };
}

